import { render, staticRenderFns } from "./AddDowntimeReason.vue?vue&type=template&id=211ea7ca"
import script from "./AddDowntimeReason.vue?vue&type=script&lang=js"
export * from "./AddDowntimeReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports